import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['unit', 'quantity', 'quantityDisplay', 'seatsToAdd', 'seatsToRemove', 'annualPrice', 'diffrencePrice', 'submitBtn', 'singlePrice', 'flexPrice', 'unlimitedPrice', 'paymentMethodLink'];

  connect() {
    this.applySeatsFromUrl();
    if (this.hasSeatsToRemoveTarget) {
      this.toggleSubmitButton(null);
    }
  }

  applySeatsFromUrl() {
    // Prefer the hidden seats input (set server-side when returning from payment methods modal via AJAX),
    // fall back to the URL param for direct full-page loads.
    const seatsInput = this.element.querySelector('input[name="seats"]');
    const seats = parseInt(seatsInput?.value) || 0;
    if (seats <= 0) return;

    const input = this.hasSeatsToAddTarget ? this.seatsToAddTarget
                : this.hasQuantityTarget   ? this.quantityTarget
                : null;
    if (!input) return;

    const max = parseInt(input.dataset.max) || 9999;
    const min = parseInt(input.dataset.min) || 0;
    input.value = Math.max(min, Math.min(max, Math.ceil(seats / 5) * 5));
    this.updateTotalQuantity();
    this.fetchEstimates();
  }

  getActiveInput() {
    if (this.hasSeatsToRemoveTarget) return this.seatsToRemoveTarget;
    if (this.hasSeatsToAddTarget) return this.seatsToAddTarget;
    return this.quantityTarget;
  }

  get currentSeats() {
    if (this.hasSeatsToAddTarget) return parseInt(this.seatsToAddTarget.value) || 0;
    if (this.hasQuantityTarget)   return parseInt(this.quantityTarget.value)   || 0;
    return 0;
  }

  incrementQuantity() { this.stepQuantity(5);  }
  decrementQuantity() { this.stepQuantity(-5); }

  stepQuantity(delta) {
    const input    = this.getActiveInput();
    const min      = parseInt(input.dataset.min) || 0;
    const max      = parseInt(input.dataset.max) || 9999;
    const newValue = (parseInt(input.value) || 0) + delta;

    if (newValue >= min && newValue <= max) {
      input.value = newValue;
      this.updateTotalQuantity();
      this.fetchEstimates();
    }
  }

  updateQuantity() {
    const input = this.getActiveInput();
    const min   = parseInt(input.dataset.min) || 0;
    const max   = parseInt(input.dataset.max) || 9999;
    let value   = parseInt(input.value) || min;

    value = Math.min(Math.max(value, min), max);
    if (value % 5 !== 0) {
      value = Math.ceil(value / 5) * 5;
      if (value > max) value = Math.floor(max / 5) * 5;
    }

    input.value = value;
    this.updateTotalQuantity();
    this.fetchEstimates();
  }

  updateTotalQuantity() {
    let totalQuantity;

    if (this.hasSeatsToRemoveTarget || this.hasSeatsToAddTarget) {
      const input  = this.hasSeatsToRemoveTarget ? this.seatsToRemoveTarget : this.seatsToAddTarget;
      const delta  = parseInt(input.value) || 0;
      const base   = parseInt(input.dataset.baseQuantity) || 0;
      totalQuantity = this.hasSeatsToRemoveTarget ? base - delta : base + delta;

      if (this.hasQuantityTarget) this.quantityTarget.value = totalQuantity;
      if (this.hasSeatsToAddTarget) this.updatePaymentMethodLinks();
    } else if (this.hasQuantityTarget) {
      totalQuantity = parseInt(this.quantityTarget.value) || 0;
      this.updatePaymentMethodLinks();
    }

    if (totalQuantity !== undefined) this.updateQuantityDisplay(totalQuantity);
  }

  updateQuantityDisplay(value) {
    if (this.hasQuantityDisplayTarget) {
      this.quantityDisplayTarget.textContent = value;
    }
  }

  updatePaymentMethodLinks() {
    if (!this.hasPaymentMethodLinkTarget) return;

    const seats = this.currentSeats;
    const unit  = this.hasUnitTarget ? this.unitTarget.value : null;

    this.paymentMethodLinkTargets.forEach(link => {
      const url = new URL(link.href);
      seats > 0 ? url.searchParams.set('seats', seats) : url.searchParams.delete('seats');
      if (unit)  url.searchParams.set('unit', unit);
      link.href = url.toString();
    });
  }

  updateUnit(event) {
    if (this.hasUnitTarget) this.unitTarget.value = event.target.value;
    this.updatePaymentMethodLinks();
    this.fetchEstimates(event.target.value);
  }

  fetchEstimates(unit = null) {
    const mode        = this.getActiveInput().dataset.mode || '';
    const currentUnit = unit || (this.hasUnitTarget ? this.unitTarget.value : 'single');
    this.fetchEstimateForUnit(currentUnit, mode);
  }

  fetchEstimateForUnit(unit, mode) {
    const quantity = this.hasQuantityTarget ? this.quantityTarget.value : 0;
    const params   = { subscription: { quantity, unit, mode } };

    Rails.ajax({
      url: `/companies/${$('#company_id').val()}/subscriptions/estimate?${jQuery.param(params)}`,
      type: 'get',
      dataType: 'json',
      success: (data) => {
        if (unit === 'single'    && this.hasSinglePriceTarget)    this.singlePriceTarget.textContent    = data.license_cost;
        if (unit === 'flex'      && this.hasFlexPriceTarget)      this.flexPriceTarget.textContent      = data.license_cost;
        if (unit === 'unlimited' && this.hasUnlimitedPriceTarget) this.unlimitedPriceTarget.textContent = data.license_cost;
        if (this.hasAnnualPriceTarget)    this.annualPriceTarget.textContent = data.annual_price;
        if (this.hasDiffrencePriceTarget) this.diffrencePriceTargets.forEach(t => t.textContent = data.total_due_today);
        this.toggleSubmitButton(data.total_due_today);
      },
      error: () => {}
    });
  }

  toggleSubmitButton(totalDueToday) {
    if (!this.hasSubmitBtnTarget) return;

    const mode = this.getActiveInput()?.dataset.mode || '';
    if (mode === 'reduce_seats' && this.hasSeatsToRemoveTarget) {
      this.submitBtnTarget.disabled = (parseInt(this.seatsToRemoveTarget.value) || 0) === 0;
    } else {
      this.submitBtnTarget.disabled = ['$0.00', '0.00', '$0', '0'].includes(totalDueToday);
    }
  }
}
